import { enBronzePalettes } from "../../../../Posts/01-paletas/14-bronce/palettes";
import * as React from 'react';
export default {
  enBronzePalettes,
  React
};